import _ from 'lodash';
import * as c from './constants';
export var createAbstract = function createAbstract(data) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    return dispatch(application.post('/api/digital-abstract/create', data)).then(function (json) {
      var error = json.error;
      if (error) {
        if (showError) {
          dispatch(application.addMessage({
            type: 'error',
            message: error.error,
            params: JSON.parse(error.getJsonEncodedParams() || '{}')
          }));
        }
      } else if (searchOnSuccess) {
        dispatch(searchAbstracts({
          page: 1
        }));
      }
      return json;
    });
  };
};
export var searchAbstracts = function searchAbstracts() {
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    dispatch({
      type: c.ABSTRACT_SEARCH_REQUESTED
    });
    return dispatch(application.get('/api/digital-abstract/search')).then(function (json) {
      var abstracts = json.results,
        pagination = json.pagination;
      dispatch({
        type: c.ABSTRACT_SEARCH_COMPLETED,
        pagination: pagination,
        abstracts: abstracts
      });
      return abstracts;
    });
  };
};
export var updateDisplayedAbstracts = function updateDisplayedAbstracts(identities) {
  return function (dispatch, getState, _ref3) {
    var _getState$abstract;
    var application = _ref3.application;
    var previousAbstracts = ((_getState$abstract = getState().abstract) === null || _getState$abstract === void 0 ? void 0 : _getState$abstract.abstracts) || [];
    return dispatch(application.get('/api/digital-abstract/search', {
      identities: identities
    })).then(function (json) {
      var abstracts = json.results;
      var keyedAbstracts = _.keyBy(abstracts, 'identity');
      abstracts.forEach(function (newAbstract) {
        var oldAbstract = previousAbstracts.find(function (abstract) {
          return abstract.identity === newAbstract.identity;
        });
        if (oldAbstract && oldAbstract.status !== newAbstract.status) {
          if (newAbstract.status === c.STATUS_COMPLETED) {
            dispatch(application.addMessage({
              type: 'success',
              message: c.ABSTRACT_GENERATION_SUCCESS_MESSAGE
            }));
          } else if (newAbstract.status === c.STATUS_FAILED) {
            dispatch(application.addMessage({
              type: 'error',
              message: c.ABSTRACT_GENERATION_FAILED_MESSAGE
            }));
          }
        }
      });
      dispatch({
        type: c.ABSTRACTS_UPDATED,
        abstracts: keyedAbstracts
      });
      return true;
    });
  };
};
export var removeAbstract = function removeAbstract(abstractIdentity) {
  return {
    type: c.ABSTRACT_ARCHIVED,
    abstractIdentity: abstractIdentity
  };
};
export var deleteAbstractFile = function deleteAbstractFile(fileIdentity) {
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    return dispatch(application.del("/api/file/delete/".concat(fileIdentity), {
      digitalAbstract: true
    }));
  };
};
export var loadDigitalAbstractLimitReached = function loadDigitalAbstractLimitReached() {
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    return dispatch(application.get('/api/digital-abstract/limit-reached')).then(function (json) {
      return json.digitalAbstractLimitReached;
    });
  };
};
export var viewAbstract = function viewAbstract(identity) {
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    dispatch({
      type: c.ABSTRACT_VIEW_REQUESTED,
      identity: identity
    });
    return dispatch(application.get("/api/digital-abstract/".concat(identity, "/view"))).then(function (json) {
      if (json.error) {
        dispatch({
          type: c.ABSTRACT_VIEW_FAILED,
          identity: identity
        });
        return null;
      }
      dispatch({
        type: c.ABSTRACT_VIEW_COMPLETED,
        identity: identity,
        abstract: json
      });
      return json;
    });
  };
};